
export default  {
    roleSetting: {
        master: {
            color: 'primary'
        },
        admin: {
            color: 'info'
        },
        presenter: {
            color: 'warning'
        },
        audience: {
            color: 'secondary'
        }
    }
}